import store from '@/store/store';

const addToVueInstance = (Vue) => {
  Vue.prototype.$isMobile = function () {
    return store.getters['isMobile'];
  };

  Vue.prototype.$isMobileApp = function () {
    return store.getters['isMobileApp'];
  };
};

export default {
  addToVueInstance,
};
